import styled from 'styled-components'

import color from '../../config/color'

export const Wrapper = styled.div`
  background-color: ${color.footer};

  p{
    padding: 10px 10px;
    color: ${color.footerText};
    text-align: center;
  }
`